import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-foreground-300">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="py-14 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <h4 className="text-white text-base font-semibold mb-4 font-heading">91tv</h4>
            <p className="text-sm leading-relaxed text-foreground-400">
              高清视频资源一站聚合平台，提供海量影视、综艺、动漫及短视频资源。
            </p>
            <div className="flex gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-700 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-white text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-700 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-white text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-700 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-white text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold mb-4 font-heading">视频分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.id}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold mb-4 font-heading">快速链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">帮助中心</a></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">用户协议</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold mb-4 font-heading">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@91tv.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-400"></i>
                <span>400-888-9191</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-400"></i>
                <span>深圳市南山区科技园</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="py-6 border-t border-foreground-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 91tv 版权所有 | 粤ICP备2024XXXXXXXX号
          </p>
          <div className="flex gap-4 text-xs">
            <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}